// Join.js
'use strict';
'use client';
import { connect } from 'react-redux';
import { goBack } from 'redux-first-history';

import Join from '../page/Join.jsx';
import withRouter from '../component/WithRouter.jsx';
import getMeData from '../selector/getMeData.js';
import getOperationData from '../selector/getOperationData.js';
import getCanSubmitJoinForm from '../selector/getCanSubmitJoinForm.js';
import getNetworkingData from '../selector/getNetworkingData.js';
import getRegisterData from '../selector/getRegisterData.js';

import addModal from '../action/addModal.js';
import proceedJoinStep from '../action/proceedJoinStep.js';
import fetchMeCreator from '../action/fetchMeCreator.js';

import { PasswordLoginEntry } from '../resource/authEntryType.js';

const mapStateToProps = (
  state,
  {
    match: {
      params: { progress },
    },
  }
) => {
  const draftEmail = getRegisterData(state, 'email');
  return {
    progress,
    meId: getMeData(state, 'id'),
    errorI18nKey: getOperationData(
      state,
      ['join', 'draft', 'error'],
      'i18nKey'
    ),
    kycStatus: getOperationData(state, ['join', 'kyc'], 'status'),
    deviceHeight: getOperationData(state, ['device'], 'height'),
    canSubmit: getCanSubmitJoinForm(state, progress),
    isSubmitMeKycFetching: getNetworkingData(
      state,
      ['submit', 'me', 'kyc'],
      'isFetching'
    ),
    isSubmitMeCreatorFetching: getNetworkingData(
      state,
      ['submit', 'me', 'creator'],
      'isFetching'
    ),
    isFetchMeCreatorFetching: getNetworkingData(
      state,
      ['fetch', 'me', 'creator'],
      'isFetching'
    ),
    isSubmitPasswordLoginFetching: getNetworkingData(
      state,
      ['passwordLogin', PasswordLoginEntry.JOIN],
      'isFetching'
    ),
    isMeAccountLinksFetching: getNetworkingData(
      state,
      ['me', 'accountLinks'],
      'isFetching'
    ),
    isEmailBindFetching: getNetworkingData(
      state,
      ['register', 'bind', 'email'],
      'isFetching'
    ),
    isEmailBindOtpFetching: getNetworkingData(
      state,
      ['register', 'emailOtp', draftEmail],
      'isFetching'
    ),
    kycFailedReasons: getOperationData(state, ['join', 'kyc'], 'failedReasons'),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    addModal: ({ id }) =>
      dispatch(
        addModal({
          id,
          transitionStatus: 'coming',
        })
      ),
    proceedJoinStep: ({ progress }) => dispatch(proceedJoinStep({ progress })),
    fetchMeCreator: () => dispatch(fetchMeCreator()),
    goBack: () => dispatch(goBack()),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Join));
